<template>
</template>

<script>
export default {
    data: function () {
        return {
            idSuffix: Math.random().toString(36).substring(7),
            error: false,
            vrm: '',
            disableOnSubmit: false,
            animation: null,
            animationComplete: false,
            redirectUrl: false,
            count: 0,
            existingReportUrl: '',
            bundlesValidData: JSON.parse(this.bundlesValid),
            bundlesNoRepeat: [],
            bundleHashid: null,
            productType: null,
            interstitials: [
                {
                    icon: 'icon-mot-tax-check',
                    text: 'Checking vehicle data from our Government databasess...',
                },
                {
                    icon: 'icon-detailed-mileage-check',
                    text: 'Checking over 350m readings in our Mileage databases...',
                },
                {
                    icon: 'icon-finance-check',
                    text: 'Checking Insurance Write-Off databases...',
                },
                {
                    icon: 'icon-finance-check',
                    text: 'Checking Finance databases...',
                },
                {
                    icon: 'icon-stolen',
                    text: 'Checking Stolen Database...',
                },
                {
                    icon: 'icon-tick',
                    text: 'Your report is now ready!',
                },
            ],
        }
    },
    props: [
        'lookupUrl',
        'bladeDisabled',
        'vueBundle',
        'voucher',
        'bundlesValid',
    ],
    computed: {
        interstitialId() {
            return 'interstitial-' + this.idSuffix;
        },
        vrmInputErrorId() {
            return 'vrm-input-error-' + this.idSuffix;
        },
        reportExistsId() {
            return 'report-exists-' + this.idSuffix;
        },
        voucherCodeFromVuex() {
            return this.$store.state.voucherCode;
        },
        productTypeFromVuex() {
            return this.$store.state.productType;
        },
        actualDisabled() {
            if (this.vueBundle) {
                return !this.vueBundle.is_valid;
            };

            return this.bladeDisabled;
        },
        actualBundleHashid() {
            if (this.vueBundle) {
                return this.vueBundle.hashid;
            };

            return this.bundleHashid;
        },
        actualproductType() {
            if (this.vueBundle) {
                return this.vueBundle.product_type;
            };

            return this.productType;
        },
    },
    created() {

    },
    mounted() {
        // HACK: The modal is declared within the component.
        // When the component is inside an element with a z-index declared
        // it respects the parent z-index. So if the modal is within the navbar
        // then it will use the navbar zindex which is lower than the modal overlay
        // So we're moving the modal and appending it to the document body
        let interstitial = $('#' + this.interstitialId).remove();
        $(document.body).append(interstitial);

        let vrmInputErrorModal = $('#' + this.vrmInputErrorId).remove();
        $(document.body).append(vrmInputErrorModal);

        let reportExistsModal = $('#' + this.reportExistsId).remove();
        $(document.body).append(reportExistsModal);

        // TODO! The hack above causes other issues - Vue can no longer interact
        // with the modals once they've been moved.
        // We need to use a bus dispatch method to trigger these modals


        // Show the buttons for each type of bundle the user has.
        var arrayLength = this.bundlesValidData.length;
        var arrayNoRepeat = [];
        for (var i = 0; i < arrayLength; i++) {
            if (!arrayNoRepeat.includes(this.bundlesValidData[i].product_type)) {
                this.bundlesNoRepeat.push(this.bundlesValidData[i]);
                arrayNoRepeat.push(this.bundlesValidData[i].product_type);
            }
        }

    },
    watch: {
        animationComplete: function (val) {
            if (val && this.redirectUrl) {
                this.redirectToResults();
            };
        },
        redirectUrl: function (val) {
            if (val && this.animationComplete) {
                this.redirectToResults();
            };
        },
        bundleHashid: function() {
            //console.log(this.bundleHashid);
            this.interstitials = this.$root.getInterstitials(this.vrm, this.actualproductType);
        },
    },
    methods: {
        isDisabled() {
            return this.actualDisabled || this.disableOnSubmit;
        },
        launchInterstitialAndLookup(scope) {
            $('#'+ this.reportExistsId).modal('hide');
            $('#vrm-input-free-report-modal').modal('hide');

            let self = this;

            self.disableOnSubmit = true;

            setTimeout(function () {
                self.disableOnSubmit = false;
            }, 1000);

            self.$validator.validateAll(scope).then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    self.runInterstitial();

                    // Delay the query until after the Interstital has loaded
                    setTimeout(function () {
                        self.queryApi();
                    }, 1200);
                }
            });
        },
        validationClass(hasErrors) {
            return hasErrors ? 'is-invalid' : null;
        },


        /**
         *
         */
        runInterstitial() {
            $('#'+ this.interstitialId).modal({backdrop: 'static', keyboard: false});

            this.count = 0;

            // Load a new interstitial every second
            this.animation = setInterval(this.loadInterstitial, 667);
        },

        /**
         * Query the internal API to trigger a free lookup on MotorCheck
         *
         * @return  {void}
         */
        queryApi() {

            let postData = {
                vrm: this.vrm,
                bundle_hashid: this.actualBundleHashid,
                voucher: this.voucher,
            };

            if (this.voucherCodeFromVuex) {
                postData.voucher = this.voucherCodeFromVuex;
            };

            if (this.voucherCodeFromVuex) {
                postData.product_type = this.productTypeFromVuex;
            };

            axios
                .post(this.lookupUrl, postData)
                .then(response => {
                    if (response.data.success == false) {
                        // Report already exists for reg
                        $('#'+ this.interstitialId).modal('hide');
                        $('#'+ this.reportExistsId).modal('show');
                        this.existingReportUrl = '/report/' + response.data.existingReportHashid + '/';
                    } else {
                        this.redirectUrl = response.data.redirect;
                    }
                })
                .catch(error => {
                    let response = error.response.data.error;

                    // alert('Registration not found');
                    $('#'+ this.interstitialId).modal('hide');

                    setTimeout(function () {
                        $('#' + this.vrmInputErrorId).modal('toggle')
                        $('.vrm-input-error-title').text(response.message);
                    }.bind(this), 100);

                })
                .finally(() => {
                })
        },
        /**
         * Load the next interstitial slide
         *
         * @return  {void}
         */
        loadInterstitial() {
            this.count++;
            if (this.count >= (this.interstitials.length - 1)) {
                clearInterval(this.animation);

                // One last timeout, so that the "Your report is ready" slide
                // stays up on the screen for a second
                setTimeout(function () {
                    this.animationComplete = true;
                }.bind(this), 667);
            }
        },

        /**
         * Redirects user to the second step of the process
         *
         * @return {void}
         */
        redirectToResults() {
            window.location = this.redirectUrl;
        },
    }
}
</script>
